module.exports = __webpack_public_path__ + "static/img/icon1-6.eebf5ca4.png";